module.exports = __webpack_public_path__ + "img/me_service_center_icon.7e02467d.svg";